/**
 * Return the input only if it's a safe http(s) URL; otherwise null.
 *
 * Defense against profile-link XSS — even though the backend
 * ``_validate_safe_url`` rejects bad schemes on save, this helper
 * stays as a second layer so a stale row, a bypassed backend, or a
 * future profile-source we render also can't inject ``javascript:``
 * / ``data:`` / ``vbscript:`` into a rendered ``<a href>``.
 *
 * Case-insensitive scheme check + leading-whitespace strip so
 * `"  JavaScript:alert(1)"` gets rejected too.
 */
export function safeHref(value: string | null | undefined): string | null {
  if (value === null || value === undefined) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  const lower = trimmed.toLowerCase();
  if (lower.startsWith("http://") || lower.startsWith("https://")) {
    return trimmed;
  }
  return null;
}
